<div class="grid-container padding-y-4">
  <div class="grid-row">
    <legend class="usa-legend usa-legend--large">Mailing List</legend>
  </div>
  @if (mailingListForm) {
    <form id="mailingListForm" role="form" [formGroup]="mailingListForm" (ngSubmit)="onSubmit()">
      <fieldset class="usa-fieldset">
        <div class="grid-row">
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
            <legend class="usa-legend text-bold">Groups</legend>
            @if (currentUser?.agencyUser && this.radioButtonList.length === 1) {
              <div>
                <input
                  class="usa-radio__input"
                  id="hhg-tsp"
                  type="radio"
                  name="hhg-tsp"
                  value="hhGoodsTSP"
                  checked="checked"
                  />
                <label class="usa-radio__label" for="hhg-tsp"
                  >Household Goods TSPs</label
                  >
                </div>
              } @else {
                @for (item of this.radioButtonList; track item) {
                  <div class="usa-radio">
                    <input class="usa-radio__input" id= '{{item.value}}' type="radio" formControlName="mailingReport"
                      checked="{{mailingListForm.get('mailingReport').value === item ? 'checked' : ''}}"
                      (change)="radioButtonSelection(item.value)" name="mailingReport" value='{{item.value}}'/>
                    <label class="usa-radio__label" for="{{item.value}}">{{item.name}}</label>
                  </div>
                }
              }
            </div>
            <!-- Start: Display when Freight /Household Goods TSPs are selected -->
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3" [hidden]="hideSocioEconomicCheckbox">
              <legend class="usa-legend text-bold">Socio-Economic Indicators</legend>
              <div class="usa-checkbox define-background-checkbox">
                <input class="usa-checkbox__input" type="checkbox" formControlName="allSocioEconIndicators" id="allSocioEconIndicators" (change)="onSocioEconomicChange($event)">
                <label class="usa-checkbox__label" for="allSocioEconIndicators">All</label>
              </div>
              @for (scIndicator of mailingListForm.get('sociaEconomicIndicators')['controls']; track scIndicator; let i = $index) {
                <div formArrayName="sociaEconomicIndicators">
                  <div class="usa-checkbox define-background-checkbox">
                    <input class="usa-checkbox__input" type="checkbox" [formControlName]="i" id="scIndicatorCheckbox{{i}}">
                    <label class="usa-checkbox__label" for="scIndicatorCheckbox{{i}}">{{sociaEconomicIndicators[i].scIndicator}}</label>
                  </div>
                </div>
              }
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3" [hidden]="hideSocioEconomicCheckbox">
              @if (!this.hideTspOfferings) {
                <legend class="usa-legend text-bold">TSP Service Offerings</legend>
              }
              @if (!this.hideTspOfferings) {
                <div class="usa-checkbox define-background-checkbox">
                  <input class="usa-checkbox__input" type="checkbox" formControlName="allServiceOfferings" id="allServiceOfferings" (change)="onTspOfferingsChange($event)">
                  <label class="usa-checkbox__label" for="allServiceOfferings">All</label>
                </div>
              }
              @for (offering of mailingListForm.get('offerings')['controls']; track offering; let i = $index) {
                <div formArrayName="offerings">
                  @if (!this.hideTspOfferings) {
                    <div class="usa-checkbox define-background-checkbox">
                      <input class="usa-checkbox__input" type="checkbox" [formControlName]="i" id="offeringCheckbox{{i}}">
                      <label class="usa-checkbox__label" for="offeringCheckbox{{i}}">{{offerings[i].serviceCode}} - {{offerings[i].serviceDescription}}</label>
                    </div>
                  }
                </div>
              }
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3" [hidden]="hideSocioEconomicCheckbox">
              @if (!this.hideProcessingTsps) {
                <legend class="usa-legend text-bold" >Processing TSPs</legend>
              }
              @if (!this.hideProcessingTsps) {
                <div class="usa-checkbox define-background-checkbox">
                  <input class="usa-checkbox__input" type="checkbox" formControlName="processingTsps" id="processingTsps">
                  <label class="usa-checkbox__label" for="processingTsps">Show only Processing TSPs</label>
                </div>
              }
              <legend class="usa-legend text-bold">Environmental Protection Agency (EPA)</legend>
              <div class="usa-checkbox define-background-checkbox">
                <input class="usa-checkbox__input" type="checkbox" formControlName="smartWay" id="smartWay">
                <label class="usa-checkbox__label" for="smartWay">Certified SmartWay TSP Partners</label>
              </div>
              <div class="required epaNote">
                Note: If one or more options under "Socio-Economic Indicators" are selected and "Certified SmartWay TSP Partners" is also selected, the query result will only identify those TSPs that satisfy both a selected socio-economic indicator and are also EPA
                Certified SmartWay TSP Partners. To see a list of only EPA Certified SmartWay TSP Partners, choose that option only.
              </div>
            </div>
            <!-- End: Display when Freight /Household Goods TSPs are selected  -->
          </div>
          <div class="grid-row grid-gap">
            @if (hideSocioEconomicCheckbox && radioSelectedValue) {
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                <label class="usa-label" for="customer-name">Customer Name</label>
                <ng-template #agencySearchTemplate let-model="item" let-index="index">
                  {{model.agencyBureauName}} - {{model.agencyCode}}
                </ng-template>
                <input class="usa-input" id="customer-name" type="text" formControlName='agencyUser' placeholder="- Select -" [typeaheadOptionsInScrollableView]="10" [typeaheadOptionsLimit]="300" [typeaheadMinLength]="0" (typeaheadOnSelect)="changeAgency($event)"
                  typeaheadOptionField="agencyBureauName" [typeahead]="agencyList" [typeaheadItemTemplate]="agencySearchTemplate" [typeaheadScrollable]="true">
              </div>
            }
            @if (hideSocioEconomicCheckbox===true && radioSelectedValue) {
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4"
                >
                <label class="usa-label" for="bureau-name">Bureau Name</label>
                <select class="usa-select" ria-label="Select bureau" formControlName="bureauUser" title="Bureau Name"
                  name="BureauNameList" id="bureau-name">
                  <option value="null">- Select -</option>
                  @for (b of bureauMaster; track b) {
                    <option [value]="b.bureauCode">{{b.bureauCode}}
                    - {{b.agencyBureauName}}</option>
                  }
                </select>
              </div>
            }
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label class="usa-label" for="zip">Zip Code</label>
              <input class="usa-input" id="zip" name="zip" type="text" formControlName="zipCode" maxlength="5">
              @if ((mailingListForm.get('zipCode').touched ||
                mailingListForm.get('zipCode').dirty) &&
                mailingListForm.get('zipCode').errors) {
                <small class="define-text-secondary">
                  @if (this.mailingListForm.get('zipCode').hasError('numeric') || this.mailingListForm.get('zipCode').hasError('zipCode')) {
                    <span>
                      <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                        <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                      </svg> Zip is invalid - should be all numeric, no dashes, no spaces<br>
                    </span>
                  }
                  @if (this.mailingListForm.get('zipCode').hasError('lengthFive')) {
                    <span>
                      <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                        <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                      </svg> Zip is invalid - should be 5 numbers<br>
                    </span>
                  }
                  @if (this.mailingListForm.get('zipCode').hasError('allZeros')) {
                    <span>
                      <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                        <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                      </svg> Zip is invalid - can't be all zeros<br>
                    </span>
                  }
                </small>
              }
            </div>
          </div>
          <div class="grid-row margin-top-2em">
            <button class="usa-button" [disabled]="null !== this.mailingListForm.get('zipCode').errors" type="submit">Query
            </button>
          </div>
        </fieldset>
      </form>
    }
    @if ((this.customerMailingListReport && this.customerMailingListReport.length > 1) ||
      (this.tspMailingListReport && this.tspMailingListReport.length > 1) ) {
      <div class="grid-row margin-top-2em">
        <img src="assets/uswds/img/usa-icons/file_download.svg" alt="user_icon">Right click on the report and select the appropriate options to export.
      </div>
    }
    <div class="grid-row margin-top-2em">
      <!-- To show Customer Mailing List Report-->
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
        @if (this.customerMailingListReport && this.customerMailingListReport.length > 0) {
          <div>
            <ag-grid-angular class="ag-theme-alpine"
              style="height: 500px;"
              [rowData]="customerMailingListReport"
              [domLayout]="domLayout"
              [pagination]="true" [masterDetail]="true"
              [detailCellRendererParams]="detailCellRendererParams"
              [paginationPageSize]="paginationPageSize"
              [excelStyles]="excelStyles"
              [columnDefs]="customerMailingListColumnDefs">
            </ag-grid-angular>
          </div>
        }
      </div>

      <!-- To show TSPs Mailing List Report-->
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
        @if (this.tspMailingListReport && this.tspMailingListReport.length > 0) {
          <div>
            <ag-grid-angular class="ag-theme-alpine"
              style="height: 500px;"
              [rowData]="tspMailingListReport"
              [domLayout]="domLayout" [pagination]="true"
              [masterDetail]="true"
              [detailCellRendererParams]="detailCellRendererParams"
              [paginationPageSize]="paginationPageSize"
              [columnDefs]="tspMailingListColumnDefs"
              (gridReady)="onGridReady($event)"
              [excelStyles]="excelStyles"
              [defaultExcelExportParams]="defaultExcelExportParams">
            </ag-grid-angular>
          </div>
        }
      </div>

    </div>
  </div>
